// extracted by mini-css-extract-plugin
export default {"NEUTRAL_500":"#424242","title":"title-e1e"};